import { Box, Button, Alert, buttonBaseClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef } from "react";
import { useIsMobile } from "@hooks";

const StyledAlert = styled(Alert)(({ theme }) => ({
  ".MuiAlert-icon": {
    color: theme.palette.common.white
  }
}));

/**
 * Severity can be "info", "success" or "warning"
 * @param alertText
 * @param dismissText
 * @param severity
 * @param handleDismiss
 * @returns {JSX.Element}
 */
// eslint-disable-next-line react/display-name
export const HyroAlert = forwardRef(
  ({ alertText, dismissText, severity, handleDismiss }, ref) => {
    const isMobile = useIsMobile();
    return (
      <StyledAlert
        ref={ref}
        variant="filled"
        severity={severity}
        sx={{ zIndex: "1301" }}
        action={(
          <Button
            size="small"
            onClick={handleDismiss}
            sx={theme => ({
              width: isMobile ? 100 : "auto",
              fontWeight: 500,
              color: theme.palette.common.white,
              [`&.${buttonBaseClasses.root}:hover`]: {
                backgroundColor: "transparent"
              }
            })}
          >
            {dismissText}
          </Button>
        )}
      >
        <Box
          fontWeight={400}
          fontSize={14}
          sx={theme => ({ color: theme.palette.common.white })}
        >
          {alertText}
        </Box>
      </StyledAlert>
    );
  });
